import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessagePropType } from '../../../../../prop-types/intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import style from '../inputs.module.less';
import { FormattedMessage } from 'react-intl';
import { ancillaryEndorsement } from '../../../../../services/other-shipping-options/constants';
import EndorsementDropdownItems from './endorsement-type';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { getLabelForEndorsementType } from './label-for-endorsement-type';
import messages from './messages';

const AncillaryEndorsement = ({ label, checked = false, optionData, updateOption }) => {
  const { value } = optionData;
  const [ancEndorsement, setAncEndorsement] = useState();
  const [isOptionChecked, setIsOptionChecked] = useState(checked);
  const onCheckChanged = useCallback(
    (isChecked) => {
      setIsOptionChecked(isChecked);
      if (!isChecked) {
        updateOption({ id: ancillaryEndorsement, value: false });
        return;
      }
      const newValue = {
        value: ancEndorsement,
      };
      updateOption({ id: ancillaryEndorsement, value: newValue });
    },
    [ancEndorsement, updateOption],
  );

  const onSetEndorsement = useCallback(
    (endorsement) => {
      setAncEndorsement(endorsement);
      const newValue = {
        value: endorsement,
      };
      updateOption({ id: ancillaryEndorsement, value: newValue });
    },
    [updateOption],
  );

  return (
    <div className={style['ancillary-endorsement']}>
      <div>
        <Checkbox checked={isOptionChecked} label={label} onChange={onCheckChanged} />
      </div>
      {isOptionChecked && (
        <div className={style['ancillary-endorsement-selector']}>
          <label>
            <FormattedMessage {...messages.ancillaryEndorsement} />
          </label>
          <DropdownMenu>
            <DropdownMenuToggler className={style['bigly-dropdown']}>
              {getLabelForEndorsementType(value) ?? <FormattedMessage {...messages.selectAncillaryEndorsement} />}
            </DropdownMenuToggler>
            <EndorsementDropdownItems onEndorsementChange={onSetEndorsement} />
          </DropdownMenu>
        </div>
      )}
    </div>
  );
};

AncillaryEndorsement.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  optionData: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
  updateOption: PropTypes.func.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default AncillaryEndorsement;
